"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Edit = function Edit(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M15.8683 6C15.7161 6 15.5639 6.05824 15.448 6.17415L14.2592 7.363L13.4186 8.20356L7.29166 14.3306C6.91659 14.7057 6.70588 15.2144 6.70588 15.7448V16.2941C6.70588 16.8464 7.1536 17.2941 7.70588 17.2941H8.25512C8.78556 17.2941 9.29427 17.0834 9.66934 16.7083L17.8257 8.55186C18.0581 8.31944 18.0581 7.94313 17.8257 7.7113L16.2886 6.17415C16.1726 6.05824 16.0205 6 15.8683 6ZM15.8824 7.05882L16.9412 8.11765L15.765 9.26238L14.7062 8.20356L15.8824 7.05882ZM14.1176 8.82353L15.1765 9.88235L13.7647 11.2941L12 13.0588L8.88382 16.175C8.84376 16.2151 8.79927 16.2505 8.75122 16.2805V16.2805C8.0778 16.7014 7.29862 15.9222 7.71951 15.2488V15.2488C7.74954 15.2007 7.78493 15.1562 7.825 15.1162L14.1176 8.82353Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M5.53577 19.6967C5.42978 19.6275 5.35761 19.5394 5.32837 19.4434C5.29912 19.3474 5.31413 19.2479 5.37149 19.1575C5.42885 19.0671 5.52598 18.9898 5.6506 18.9354C5.77522 18.8811 5.92174 18.8521 6.07163 18.8521L18.9322 18.8521C19.1325 18.8527 19.3242 18.9052 19.4655 18.9979C19.6068 19.0906 19.6861 19.2161 19.6861 19.3469C19.6861 19.4776 19.6068 19.6031 19.4655 19.6958C19.3242 19.7885 19.1325 19.841 18.9322 19.8416L6.07159 19.8416C5.97206 19.8417 5.87349 19.829 5.78154 19.8041C5.68958 19.7792 5.60606 19.7427 5.53577 19.6967Z",
    fill: props.foregroundColor
  }));
};

Edit.defaultProps = {
  altText: "Edit",
  foregroundColor: "#2D5AB4"
};
Edit.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Edit;
exports.default = _default;